import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { AppAsyncThunkAPI } from '../..';
import api from '../marketplace/api';
import { WaterBodyDefinition } from './models';

export const updateWaterBodyDefinitions = createAction(
  '[prepare] update water body definitions',
  (waterBodyDefinitions: WaterBodyDefinition[]) => ({
    payload: waterBodyDefinitions,
  }),
);

export const fetchWaterBodyDefinitions = createAsyncThunk<
  void,
  void,
  AppAsyncThunkAPI
>(
  '[prepare] fetch water body definitions',
  async (_, { dispatch, rejectWithValue }) => {
    let waterBodyDefinitions;

    try {
      waterBodyDefinitions = await api.getWaterBodyDefinitions();
    } catch (e: any) {
      rejectWithValue(e.message);
    }

    dispatch(updateWaterBodyDefinitions(waterBodyDefinitions?.data || []));
  },
);

export const resetPrepare = createAction('[prepare] reset');
